var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 1H4.33333C3.44928 1 2.60143 1.35119 1.97631 1.97631C1.35119 2.60143 1 3.44928 1 4.33333V31C1 31.8841 1.35119 32.7319 1.97631 33.357C2.60143 33.9821 3.44928 34.3333 4.33333 34.3333H24.3333C25.2174 34.3333 26.0652 33.9821 26.6904 33.357C27.3155 32.7319 27.6667 31.8841 27.6667 31V11M17.6667 1L27.6667 11M17.6667 1L17.6667 11H27.6667M14.3333 27.6667V17.6667M9.33333 22.6667H19.3333",
    stroke: "#23782D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.35c68f3d2a34f80901cb9d79a9dce0a2.svg";
export { ForwardRef as ReactComponent };